<template>
  <svg
    v-tooltip="$t('misc.endPage')"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    class="end-of-page"
    :title="$t('misc.endPage')"
    role="presentation"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M0 2560 l0 -2560 2560 0 2560 0 0 2560 0 2560 -2560 0 -2560 0 0 -2560z m1880 1510 l0 -149 -147 -3 -148 -3 -3 -602 -2 -603 -150 0 -150 0 0 605 0 605 -150 0 -150 0 0 150 0 150 450 0 450 0 0 -150z m602 -152 l3 -303 150 0 150 0 3 303 2 303 148 -3 147 -3 3 -752 2 -753 -150 0 -150 0 0 300 0 300 -155 0 -155 0 0 -300 0 -300 -150 0 -150 0 0 748 c0 412 3 752 7 755 3 4 71 7 150 7 l143 0 2 -302z m1658 152 l0 -150 -225 0 -225 0 0 -155 0 -155 150 0 150 0 0 -150 0 -150 -150 0 -150 0 0 -150 0 -150 225 0 225 0 0 -150 0 -150 -375 0 -375 0 0 755 0 755 375 0 375 0 0 -150z m-2410 -1810 l0 -150 -225 0 -225 0 0 -150 0 -150 150 0 150 0 0 -150 0 -150 -150 0 -150 0 0 -155 0 -155 225 0 225 0 0 -150 0 -150 -375 0 -375 0 0 755 0 755 375 0 375 0 0 -150z m749 -196 c80 -190 148 -347 153 -350 4 -3 8 153 8 345 l0 351 150 0 150 0 -2 -752 -3 -753 -146 -3 c-143 -2 -146 -2 -156 20 -5 13 -72 172 -148 353 -76 182 -142 334 -147 339 -4 6 -8 -153 -8 -352 l0 -363 -147 3 -148 3 -3 753 -2 752 152 0 153 0 144 -346z m1314 331 c169 -44 299 -174 336 -336 6 -25 11 -198 11 -405 0 -303 -3 -369 -16 -415 -53 -177 -189 -300 -364 -328 -36 -6 -167 -11 -292 -11 l-228 0 0 755 0 755 248 0 c187 0 262 -4 305 -15z"
      />
      <path
        d="M3540 1655 l0 -457 93 4 c102 4 143 20 181 71 20 27 21 41 24 376 l3 347 -23 34 c-44 64 -69 75 -179 78 l-99 4 0 -457z"
      />
    </g>
  </svg>
</template>

<style lang="scss">
.end-of-page {
  width: 24px;
  height: 24px;
  display: block;
  margin: 2rem auto;
  border: 0;
  cursor: help;
  color: color('neutral-dark');
  opacity: 0.5;
}
</style>
